import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useRoyaltiesRegistrationGate } from './useRoyaltiesRegistrationGate';

/** Once cleared, stays cleared: a stale-cache re-check must not tear down a half-filled MSR2 form. */
export const useRoyaltiesRegistrationClearance = (
  resourceKey: null | string,
) => {
  const { workspaceId } = useParams();
  const gate = useRoyaltiesRegistrationGate();
  const clearanceKey = `${workspaceId}:${resourceKey}`;
  const [clearedKey, setClearedKey] = useState<string>();

  if (gate.status === 'allowed' && clearedKey !== clearanceKey) {
    setClearedKey(clearanceKey);
  }

  const isCleared = gate.status === 'allowed' || clearedKey === clearanceKey;

  return {
    isCleared,
    isPending: !isCleared && gate.status === 'pending',
    isRefused: !isCleared && gate.status !== 'pending',
    /** Set when the refusal is a failed check rather than a verdict. */
    retry: !isCleared && gate.status === 'blocked' ? gate.retry : undefined,
  };
};
